import { forwardRef, type Ref, type SVGProps } from "react";
function SvgUserGroup(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.263 13.145c2.925-1.263 6.56.338 7.686 4.803.275 1.088-.603 2.052-1.685 2.052h-4.298M10.833 7.152c0 1.74-1.358 3.151-3.034 3.151S4.766 8.892 4.766 7.152C4.766 5.41 6.124 4 7.799 4c1.676 0 3.034 1.411 3.034 3.152m8.4 0c0 1.74-1.358 3.151-3.033 3.151-1.676 0-3.034-1.411-3.034-3.151C13.166 5.41 14.524 4 16.2 4s3.033 1.411 3.033 3.152M11.73 20H3.735c-1.082 0-1.959-.97-1.684-2.057 1.758-6.954 9.605-6.954 11.363 0C13.69 19.03 12.813 20 11.73 20"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUserGroup);
export default ForwardRef;
